import { render } from "./AutoDiscount.vue?vue&type=template&id=7e51511a&scoped=true"
import script from "./AutoDiscount.vue?vue&type=script&lang=js"
export * from "./AutoDiscount.vue?vue&type=script&lang=js"

import "./AutoDiscount.vue?vue&type=style&index=0&id=7e51511a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e51511a"]])

export default __exports__